import API from "../../../app/api";

export const getCustomers = async (search = "") => {
  try {
    const response = await API.get("/customers", {
      params: {
        q: search
      },
    });

    if (response.data?.success) {
      return response.data.data || [];
    }

    return [];
  } catch (error) {
    console.log("Customer API Error:", error);
    return [];
  }
};